import React from 'react';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import { observer } from 'mobx-react';
import { action, extendObservable } from 'mobx';
import store from '../../../stores/store';
import { SERVER_ERROR } from '../../../helpers/messageText';
import { BT_FROM_EMAIL_ADDRESS } from '../../../helpers/constants';
import FieldEmailAddress from '../../_shared/Fields/EmailAddress';
import * as validate from '../../../helpers/formValidation';

const ForgottenForm = observer(
    class ForgottenForm extends React.Component {
        constructor() {
            super();

            this.form = extendObservable(this, {
                emailAddress: '',
                emailAddressFieldState: true,
                error: null,
                pending: false,

                set: action((field, value) => {
                    this[field] = value;
                }),
                get canSubmitForm() {
                    return this.emailAddressFieldState && this.emailAddress;
                },
            });
        }

        handleSubmit = event => {
            event.preventDefault();

            const body = 'emailAddress=' + this.form.emailAddress;
            this.form.set('pending', true);
            store.user
                .forgotPassword(body)
                .then(json => {
                    this.form.set('pending', false);
                    //console.log(this.props);
                    this.props.history.push('/forgottenconfirmation');
                })
                .catch(e => {
                    this.form.set('pending', false);
                    this.props.history.push('/forgottenconfirmation');
                    /* if (
                        e !== undefined &&
                        e.spread !== undefined &&
                        e.spread.Details !== undefined &&
                        e.spread.Details.Error !== undefined
                    ) {
                        this.form.set('error', e.spread.Details.Error);
                    } else {
                        this.form.set('error', 'Error');
                    } */
                });
        };

        handleChange = e => {
            switch (e.target.name) {
                case 'emailAddress':
                    // Email format validation
                    let errEmailAddressCount = validate.required(e.target.value);
                    errEmailAddressCount += validate.emailAddress(e.target.value);
                    this.form.set('emailAddressFieldState', errEmailAddressCount === 0);
                    this.form.set('emailAddress', e.target.value);
                    break;

                default:
                    break;
            }
        };

        onReturnHandler = () => {
            this.props.history.push('/login');
        };

        render() {
            return (
                <div>
                    {/* <!-- Form --> */}
                    <div className="mt-3">
                        {this.form.error !== null && (
                            <div className="alert alert-danger mt-4" role="alert">
                                {this.form.error === '' ? SERVER_ERROR : this.form.error}
                            </div>
                        )}
                        <form className="" onSubmit={this.handleSubmit}>
                            <legend>
                                <span className="legend-border-bottom">Forgot your Sign in?</span>
                            </legend>
                            <hr />
                            <p>
                                Please enter your email address below and we will help you sign in
                                as soon as possible.
                            </p>
                            <FieldEmailAddress
                                handleChange={this.handleChange}
                                fieldState={this.form.emailAddressFieldState}
                                defaultValue={this.form.emailAddress}
                            />
                            <div className="form-group row">
                                <div className="col-sm-10 offset-sm-2">
                                    <LaddaButton
                                        className="btn btn-primary btn-block"
                                        loading={this.form.pending}
                                        onClick={this.handleSubmit}
                                        disabled={!this.form.canSubmitForm}
                                        data-size={S}
                                        data-style={SLIDE_LEFT}
                                        data-spinner-size={30}
                                        data-spinner-color="#fff"
                                        data-spinner-lines={12}
                                    >
                                        Email me
                                    </LaddaButton>
                                </div>
                            </div>
                        </form>
                    </div>
                    {/* <!-- Items below Form --> */}
                    <div className="">
                        <hr />
                        <div className="row justify-content-center pl-3 pr-3 pb-2">
                            <a
                                onClick={this.onReturnHandler}
                                className="col-sm-10 offset-sm-2 btn btn-outline-primary no-outline"
                            >
                                Return to Sign in
                            </a>
                        </div>

                        <div className="alert alert-info mt-3" role="alert">
                            <strong>If you don’t see your reset email...</strong>
                            <br /> Be sure to check your spam filter for an email from {BT_FROM_EMAIL_ADDRESS}
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export default ForgottenForm;



// WEBPACK FOOTER //
// ./src/containers/PublicArea/components/ForgottenForm.js